import { render } from "./SubTitle.vue?vue&type=template&id=5a5f601d&scoped=true"
import script from "./SubTitle.vue?vue&type=script&lang=js"
export * from "./SubTitle.vue?vue&type=script&lang=js"

import "./SubTitle.vue?vue&type=style&index=0&id=5a5f601d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5f601d"]])

export default __exports__